export const CAMPAIGN_STATES = "CAMPAIGN_STATES";
export const UPDATE_FORM_FIELDS = "UPDATE_FORM_FIELDS";


export const updateCampaignState = (status) => ({
  type: CAMPAIGN_STATES,
  status,
});

export const updateCampaignFields = (status) => ({
  type: UPDATE_FORM_FIELDS,
  status,
});
